import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
const BASEURL = 'siscred-api-dividendos/v1/remesas/';
const getInformeDesg = async (tipoSeguro: string, nombreCompania: string, codigoPoliza: string, fechaRemesa: Date) => {
    const axiosResponse: AxiosResponse = await axiosInstance.get(`${BASEURL}obtener-informe-segdesg`,
        {
            params: {
                tipoSeguro,
                nombreCompania,
                codigoPoliza,
                fechaRemesa
            }
        }
    );
    return axiosResponse;
}


export {
    getInformeDesg
}